import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Navbars from '../../common/Navbar';
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import NoImage from '../../assets/img/noimages.jpg';
import './index.css'


import AOS from "aos";
import "aos/dist/aos.css";

const PayPage = ({ customerList, setCustomerList }) => {
  const { customerId } = useParams();
  const navigate = useNavigate();

  const [closedDate,setClosedDate] = useState("")
 const [loanClosed, setLoanClosed] = useState(false);
 const [calculationAmt,setCalculationAmt] = useState("")
const [isPrincipalEdited, setIsPrincipalEdited] = useState(false);

    useEffect(() => {
          AOS.init({
            duration: 1000,  
            once: false,    
            mirror: true,    
          });
        }, []);

  useEffect(() => {
    if (!loanClosed) return;

    // 1. Update status and start blink
    setPaidStatus("Closed");
    setBlinkClosed(true);

    // 2. Stop blink after 10 seconds and navigate
    const timer = setTimeout(() => {
      setBlinkClosed(false);
      navigate("/customer-details-list");
    }, 10000); // 10 seconds

    // 3. Cleanup in case component unmounts
    return () => clearTimeout(timer);
  }, [loanClosed, navigate]);

  const [customer, setCustomer] = useState(null);
  const [payAmount, setPayAmount] = useState('');
  const [principalPay, setPrincipalPay] = useState('');
  const [remainingAmount, setRemainingAmount] = useState(0);

const [isInterestEdited, setIsInterestEdited] = useState(false);

  const [remainingAmountOnly, setRemainingAmountOnly] = useState(0);
const [principalPaid, setPrincipalPaid] = useState(0);
const [interestPaid, setInterestPaid] = useState(0);


const today = new Date();
const todatDates = new Date().toLocaleDateString("en-GB").replaceAll("/", "-");






  const [paymentMethod, setPaymentMethod] = useState("");
  const [upiNumber, setUpiNumber] = useState("");

  console.log(customer);

  // ✅ Function to calculate interest

//  const calculateInterest = (cust) => {
//   const today = new Date();

//   const loanStartDate = cust.date && cust.date !== "0000-00-00"
//     ? new Date(cust.date)
//     : today;

//   // first month always counts as 1 month
//   const lastDate = loanStartDate;

//   const diffTime = today - lastDate;
//   const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

//   let months = 1;   // minimum always 1 month

//   if (diffDays <= 30) {
//     months = 1;   // 1 month interest
//   } 
//   else if (diffDays <= 45) {
//     months = 1.5; // 1.5 months interest
//   } 
//   else {
//     // after 45 days → full additional month interest
//     const extraDays = diffDays - 30; // after 1st month
//     const fullMonths = Math.floor(extraDays / 30);
//     const remainingDays = extraDays % 30;

//     months = 1 + fullMonths + (remainingDays > 15 ? 1 : 0);
//   }

//   const loanAmount = Number(cust.loan_amount || 0);
//   const rate = Number(cust.intrest_rate || 0);

//   const interest = loanAmount * (rate / 100) * months;

//   return { interest: Number(interest.toFixed(2)), months };
// };




// const calculateInterest = (cust) => {
//   const today = new Date();

//   // ------ MAIN LOAN INTEREST ------
//   const mainDate = cust.date && cust.date !== "0000-00-00"
//     ? new Date(cust.date)
//     : today;

//   const diffMain = Math.floor((today - mainDate) / (1000 * 60 * 60 * 24));

//   const mainMonths =
//     diffMain <= 30 ? 1 :
//     diffMain <= 45 ? 1.5 :
//     1 + Math.floor((diffMain - 30) / 30) + ((diffMain - 30) % 30 > 15 ? 1 : 0);

//   // FIX: use previous_loan_amount
//   const mainLoan = Number(cust.previous_loan_amount || 0);
//   const rate = Number(cust.intrest_rate || 0);

//   const mainInterest = mainLoan * (rate / 100) * mainMonths;



//   // ------ ADDITIONAL LOAN INTEREST ------
//   let addInterest = 0;

//   if (cust.additional_loan_amt) {
//     const addDate = new Date(cust.additional_loan_date);

//     const diffAdd = Math.floor((today - addDate) / (1000 * 60 * 60 * 24));

//     const addMonths =
//       diffAdd <= 30 ? 1 :
//       diffAdd <= 45 ? 1.5 :
//       1 + Math.floor((diffAdd - 30) / 30) + ((diffAdd - 30) % 30 > 15 ? 1 : 0);

//     addInterest =
//       Number(cust.additional_loan_amt) * (rate / 100) * addMonths;
//   }

//   const totalInterest = mainInterest + addInterest;

//   return {
//     interest: Number(totalInterest.toFixed(2)),
//     mainMonths,
//   };
// };




// const getMonthCount = (diffDays) => {
//   if (diffDays <= 30) return 1;

//   const fullMonths = Math.floor(diffDays / 30);
//   const extraDays = diffDays % 30;

//   let extraMonth = 0;
//   if (extraDays > 15) extraMonth = 1;
//   else if (extraDays > 0) extraMonth = 0.5;

//   return fullMonths + extraMonth;
// };

// const calculateInterest = (cust) => {
//   const today = new Date();
//   const rate = Number(cust.intrest_rate || 0);

//   // MAIN LOAN
//   const mainDate = cust.date ? new Date(cust.date) : today;
//   const diffMain = Math.floor((today - mainDate) / (1000 * 60 * 60 * 24));
//   const mainMonths = getMonthCount(diffMain);

//   const mainLoan = Number(cust.previous_loan_amount || 0);
//   const mainInterest = mainLoan * (rate / 100) * mainMonths;

//   // ADDITIONAL LOAN
//   let addInterest = 0;
//   let addMonths = 0;

//   if (cust.additional_loan_amt && cust.additional_loan_date) {
//     const addDate = new Date(cust.additional_loan_date);
//     const diffAdd = Math.floor((today - addDate) / (1000 * 60 * 60 * 24));
//     addMonths = getMonthCount(diffAdd);

//     addInterest =
//       Number(cust.additional_loan_amt) * (rate / 100) * addMonths;
//   }

//   return {
//     interest: Number((mainInterest + addInterest).toFixed(2)),
//     mainMonths,
//     addMonths
//   };
// };



const getMonthCount = (diffDays) => {
  if (diffDays <= 30) return 1;

  const fullMonths = Math.floor(diffDays / 30);
  const extraDays = diffDays % 30;

  let extraMonth = 0;

  if (extraDays === 0) {
    extraMonth = 0;
  } 
  else if (extraDays <= 15) {
    extraMonth = 0.5;
  } 
  else {
    extraMonth = 1;
  }

  return fullMonths + extraMonth;
};


const calculateInterest = (cust) => {
  const today = new Date();
  const rate = Number(cust.intrest_rate || 0);

  const mainLoan = Number(cust.previous_loan_amount || 0);
  const addLoan = Number(cust.additional_loan_amt || 0);

  const mainDate = cust.date ? new Date(cust.date) : today;
  const diffMain = Math.floor((today - mainDate) / (1000 * 60 * 60 * 24));
  let mainMonths = getMonthCount(diffMain);

  let addMonths = 0;

  // 🔥 FIXED: Only apply 1 month if NO previous days (same day)
  if (
    cust.additional_loan_amt &&
    cust.additional_loan_date
  ) {
    const addDate = new Date(cust.additional_loan_date);
    const diffAdd = Math.floor((today - addDate) / (1000 * 60 * 60 * 24));

    if (diffAdd === 0) {
      addMonths = 1;        // Same-day loan = 1 month
    } else {
      addMonths = getMonthCount(diffAdd);  // Normal calculation
    }
  }

  // Calculate interest
  const mainInterest = mainLoan * (rate / 100) * mainMonths;
  const addInterest = addLoan * (rate / 100) * addMonths;

  return {
    interest: Number((mainInterest + addInterest).toFixed(2)),
    mainMonths,
    addMonths
  };
};





// const calculateInterest = (cust) => {
//   const today = new Date();

//   // MAIN LOAN MONTHS
//   const mainDate = cust.date && cust.date !== "0000-00-00"
//     ? new Date(cust.date)
//     : today;

//   const diffMain = Math.floor((today - mainDate) / (1000 * 60 * 60 * 24));

//   const mainMonths =
//     diffMain <= 30 ? 1 :
//     diffMain <= 45 ? 1.5 :
//     1 + Math.floor((diffMain - 30) / 30) + ((diffMain - 30) % 30 > 15 ? 1 : 0);


//   // ADDITIONAL LOAN MONTHS
//   let addMonths = 0;
//   let addInterest = 0;
//   const rate = Number(cust.intrest_rate || 0);

//   if (cust.additional_loan_amt) {
//     const addDate = new Date(cust.additional_loan_date);
//     const diffAdd = Math.floor((today - addDate) / (1000 * 60 * 60 * 24));

//     addMonths =
//       diffAdd <= 30 ? 1 :
//       diffAdd <= 45 ? 1.5 :
//       1 + Math.floor((diffAdd - 30) / 30) + ((diffAdd - 30) % 30 > 15 ? 1 : 0);

//     addInterest =
//       Number(cust.additional_loan_amt) * (rate / 100) * addMonths;
//   }

//   const mainLoan = Number(cust.previous_loan_amount || 0);
//   const mainInterest = mainLoan * (rate / 100) * mainMonths;

//   const totalInterest = mainInterest + addInterest;

//   return {
//     interest: Number(totalInterest.toFixed(2)),
//     mainMonths,
//     addMonths   // 👈 ADD THIS
//   };
// };






//   useEffect(() => {
//     const cust = customerList?.find(c => String(c.id) === String(customerId));
//     if (!cust) {
//       toast.error("Customer not found");
//       navigate("/customer-details-list");
//       return;
//     }

//     setCustomer(cust);
//     const { interest } = calculateInterest(cust);
// const remaining = Number(cust.total_amount || 0) - Number(cust.paid_amount || 0);
//     setRemainingAmount(remaining.toFixed(2)+interest);
//   }, [customerId, customerList, navigate]);


useEffect(() => {
  const cust = customerList?.find(c => String(c.id) === String(customerId));
  if (!cust) {
    toast.error("Customer not found");
    navigate("/customer-details-list");
    return;
  }

  setCustomer(cust);

  console.log(cust);
  

  const { interest } = calculateInterest(cust);

  console.log(interest);
  

  let remaining = 0;

// If loan closed → always show 0
if (cust.paid_status === "Closed") {
  setRemainingAmount("0.00");
} else {
  const remainingBase =
    Number(cust.balance || 0) ;

    console.log(remainingBase);
    

  const finalRemaining = Number(remainingBase) + Number(interest);

  setRemainingAmountOnly(remainingBase)
  setRemainingAmount(finalRemaining.toFixed(2));
  console.log(finalRemaining);
  
}


//   const remaining =
//     Number(cust.total_amount || 0) - Number(cust.paid_amount || 0);

//   const finalRemaining = Number(remaining) + Number(interest);
// console.log(finalRemaining);


//   setRemainingAmount(finalRemaining.toFixed(2));


}, [customerId, customerList, navigate]);


  // ✅ Payment handler
  
 const [blinkClosed, setBlinkClosed] = useState(false);
 const [paidStatus, setPaidStatus] = useState(customer?.paid_status);

const [submit, setSubmit] = useState(false);

const[todatDate,setTodayDate] = useState("")

 
const handlePay = async () => {
  setSubmit(true);

  const principalValue = parseFloat(principalPay || 0);
  const interestValue = parseFloat(payAmount || 0);
  const remainingValue = parseFloat(remainingAmountOnly || 0);
  const maxLoan = parseFloat(customer?.loan_amount ?? 0);

  const now = new Date();

  // Format date for backend
  const payloadDate = `${now.getFullYear()}-${String(
    now.getMonth() + 1
  ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours()
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
    now.getSeconds()
  ).padStart(2, "0")}`;

  // Calculate total interest
  const totalInterest = calculateInterest(customer).interest;
  const prevInterestPaid = customer?.interest_paid === "paid" ? totalInterest : Number(customer?.interest_paid || 0);

  // Check if interest already paid this month
  let alreadyPaidThisMonth = false;
  if (customer?.interest_paid === "paid") {
    alreadyPaidThisMonth = true;
  } else if (prevInterestPaid >= totalInterest) {
    alreadyPaidThisMonth = true;
  }


  
const fullPrincipalEntered = principalValue > 0 && (remainingValue === 0 || principalValue >= remainingValue);
const fullInterestEntered = interestValue >= calculateInterest(customer).interest;

if (fullPrincipalEntered && fullInterestEntered && !closedDate) {
  toast.error("⚠️ Please select Loan Closed Date to fully settle the loan");
  setSubmit(false);
  return;
}



  // 1️⃣ Validation for full principal without closed date
  if (principalValue > 0 && principalValue === remainingValue && !closedDate) {
    toast.error("⚠️ Please select Loan Closed Date to fully settle the loan");
    setSubmit(false);
    return;
  }
  
  // Principal FULL + Interest entered + No closed date = BLOCK
if (
  principalValue > 0 &&
  principalValue === remainingValue &&
  interestValue > 0 &&
  !closedDate
) {
  toast.error("⚠️ Please select Loan Closed Date to fully settle the loan");
  setSubmit(false);
  return;
}



  // 2️⃣ Block empty payment
  if (interestValue <= 0 && principalValue <= 0) {
    toast.error("Enter a valid payment amount or principal");
    setSubmit(false);
    return;
  }

  // 3️⃣ Full loan closing requires full interest
  if (principalValue === maxLoan && !alreadyPaidThisMonth && interestValue <= 0) {
    toast.error("⚠️ You must pay the full interest before closing the loan.");
    setSubmit(false);
    return;
  }

  // 4️⃣ Prevent paying interest again this month
  if (interestValue > 0 && alreadyPaidThisMonth) {
    toast.error("❗ இந்த மாத வட்டி ஏற்கனவே செலுத்தப்பட்டுள்ளது.");
    setSubmit(false);
    return;
  }

  // Determine interest to save in this txn
  const interestPaymentThisTxn = alreadyPaidThisMonth ? 0 : interestValue;
  const newInterestPaid = alreadyPaidThisMonth ? "paid" : prevInterestPaid + interestPaymentThisTxn;

  // ===== Remaining Loan Calculation =====
  const prevRemaining = Number(
    customer.remaining_balance ||
      customer.balance ||
      customer.loan_amount ||
      0
  );
  const newRemainingLoan = Math.max(prevRemaining - principalValue, 0);
  const isClosed = newRemainingLoan === 0;

  // ===== Payment History =====
  const newPaymentRecord = {
    month_no: (customer.paymentHistory?.length || 0) + 1,
    payment_date: payloadDate,
    interest_paid: interestPaymentThisTxn,
    principal_paid: principalValue,
    balance: newRemainingLoan.toFixed(2),
  };
  const updatedPaymentHistory = [...(customer.paymentHistory || []), newPaymentRecord];

  // ===== Updated Customer Object =====
  const updatedCustomer = {
    ...customer,
    paid_amount: (principalValue + (interestPaymentThisTxn || 0)).toFixed(2),
    interest_paid: newInterestPaid,
    principal_paid: principalValue.toFixed(2),
    last_payment_date: payloadDate,
    remaining_balance: newRemainingLoan.toFixed(2),
    paid_status: isClosed ? "Closed" : "Active",
    closed_date: isClosed ? payloadDate : customer.closed_date,
    paymentHistory: updatedPaymentHistory,
  };

  // ================= Backend Payload =================
   const apiData = {
      customerDetails: {
        id: updatedCustomer.id,
        name: updatedCustomer.name,
        date: updatedCustomer.date,
        phone_no: updatedCustomer.phone_no,
        alter_phone_no: updatedCustomer.alter_phone_no,

        loan_amount: updatedCustomer.previous_loan_amount,
        intrest_rate: updatedCustomer.intrest_rate,
        duration_type: updatedCustomer.duration_type,
        duration: updatedCustomer.duration,

        intrest_amount: interest,

        // intrest_amount: updatedCustomer.intrest_amount,
        total_amount: updatedCustomer.total_amount,
        paid_amount: updatedCustomer.paid_amount,
        interest_paid: updatedCustomer.interest_paid,
        principal_paid: updatedCustomer.principal_paid,

        last_payment_date: updatedCustomer.last_payment_date,
        paid_status: updatedCustomer.paid_status,
        closed_date: updatedCustomer.closed_date,

        aadhar_no: updatedCustomer.aadhar_no,
        release_date: updatedCustomer.release_date,
        address: updatedCustomer.address,
        live_img: updatedCustomer.live_img,
        aadhar_img: updatedCustomer.aadhar_img,
        aadhar_img_1: updatedCustomer.aadhar_img_1,
        jewel_img: updatedCustomer.jewel_img,
        guardian_name:updatedCustomer.guardian_name,
        jewel_name:updatedCustomer.jewel_name,
      jewel_weight:updatedCustomer.jewel_weight,
      jewel_amount:updatedCustomer.jewel_amount,
      jewel_dust_weight:updatedCustomer.jewel_dust_weight,
        optional_img: updatedCustomer.optional_img,
        created_by: updatedCustomer.created_by,
        loan_close_date :closedDate,
        pay_method :paymentMethod,
        upi_number :upiNumber,
        additional_loan_amt :updatedCustomer.additional_loan_amt ,
        additional_loan_date :updatedCustomer.additional_loan_date ,

        // ✅ Send correct remaining balance
        balance: newRemainingLoan.toFixed(2),
      },
    };


  try {
    const response = await superAdminApis.customerDetailsUpdateAPI(apiData);
    setSubmit(false);

    if (response?.apiStatus?.code === "200") {
      toast.success(isClosed ? "Loan fully paid and closed!" : "Payment successful!");
      navigate("/customer-details-list");
    } else {
      toast.error("Failed to update payment");
    }
  } catch (err) {
    setSubmit(false);
    toast.error("Error while saving payment details.");
  }
};




  if (!customer) return null;

const { interest, mainMonths, addMonths } = calculateInterest(customer);

console.log(addMonths,interest);



  const handleBackCustomer = () => navigate('/customer-details-list');

  // ✅ Check if already paid interest this month

  
  const hasPaidThisMonth = (() => {
    if (!customer?.last_payment_date) return false;
    const lastPay = new Date(customer.last_payment_date);
    const today = new Date();
    return (
      lastPay.getFullYear() === today.getFullYear() &&
      lastPay.getMonth() === today.getMonth()
    );
  })();



  const interests = Number(customer?.interest_amount || 0); 
const suggestion = interests; 



  return (
    <div>
      <Navbars />
      <div className="container all-modules-height card p-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-4">
          <h5 className="heading-with-line mb-2 mb-md-0 aquanew-text-effect">
            Pay Loan Amount - Customer Name - {customer?.name}
            <hr className="smooth-line" />
          </h5>

          <button className="btn add-customer" onClick={handleBackCustomer}>
            <i className="fa fa-arrow-left me-2"></i> Back
          </button>
        </div>

        <div className="shadow p-2"  data-aos="fade-up">
         <div className="card-body">

    {/* <h5 className="card-title mb-3">📌 Loan Information</h5> */}



{/* Additional Loan Data ONLY if condition true */}
{customer?.additional_loan_amt && (
  <>
  <div className='row'>
<div className="col-4 mb-4">
      <p className="mb-1 text-muted small">Additional Loan Amount</p>
      <h6 className="fw-bold">₹{customer?.additional_loan_amt}</h6>
    </div>

    <div className="col-4 mb-4">
      <p className="mb-1 text-muted small">Additional Loan Date</p>
      <h6 className="fw-bold">
        {customer?.additional_loan_date
          ? customer.additional_loan_date.split(" ")[0].split("-").reverse().join("-")
          : "-"}
      </h6>
    </div>

    {/* TOTAL LOAN AMOUNT - ONLY IF ADDITIONAL LOAN */}
    <div className="col-4 mb-4">
      <p className="mb-1 text-muted small">Total Loan Amount</p>
      <h6 className="fw-bold">₹{customer?.loan_amount}</h6>
    </div>
  </div>
    
  </>
)}



    <div className="row">
       {customer?.additional_loan_amt ? 
        <div className="col-3 mb-3 highlight-remaining">
        <p className="mb-1 text-muted small">Loan Amount</p>
        <h6 className="fw-bold">₹{customer?.previous_loan_amount}</h6>
      </div>
      :
       <div className="col-3 mb-3">
        <p className="mb-1 text-muted small">Total Loan Amount</p>
        <h6 className="fw-bold">₹{customer?.loan_amount}</h6>
      </div>
       }
     

      <div className="col-3 mb-3">
        <p className="mb-1 text-muted small">Interest Rate</p>
        <h6 className="fw-bold">{customer?.intrest_rate}%</h6>
      </div>

      <div className="col-3 mb-3">
        <p className="mb-1 text-muted small">Loan Start Date</p>
       <h6 className="fw-bold">
  {customer?.date
    ? customer.date.split(" ")[0].split("-").reverse().join("-")
    : "-"
  }
</h6>

      </div>

      <div className="col-3 mb-3">
<p className="mb-1 text-muted small">Remaining Amount Only</p>
<h6 className="fw-bold">{remainingAmountOnly==0?customer?.loan_amount:remainingAmountOnly}</h6>
      </div>






{
  !hasPaidThisMonth ? (
    <>
      <div className={`${addMonths > 0 ? "col-2" : "col-3"} mb-3 mt-3`}>
        <p className="mb-1 text-muted small">Today</p>
        <h6 className="fw-bold">{todatDates}</h6>
      </div>

      {/* <div className="col-3 mb-3 mt-3">
        <p className="mb-1 text-muted small">Full Months Since Last Payment</p>
        <h6 className="fw-bold">{mainMonths} month(s)</h6>
      </div> */}

<div className={`${addMonths > 0 ? "col-4" : "col-3"} d-flex gap-5 mb-3 mt-3`}>
  {/* Main Loan Month - always shown */}
  <div>
    <p className="mb-1 text-muted small">Main Loan Month</p>
    <h6 className="fw-bold">{mainMonths} month(s)</h6>
  </div>

  {/* Additional Loan Month - only if exists */}
  {addMonths > 0 && (
    <div>
      <p className="mb-1 text-muted small">Additional Loan Month</p>
      <h6 className="fw-bold">{addMonths} month(s)</h6>
    </div>
  )}
</div>


    </>
  ) : (
    <>
      <div className="col-3 mb-3 mt-3">
        <p className="mb-1 text-muted small">Today</p>
        <h6 className="fw-bold">{todatDates}</h6>
      </div>

    <div className="col-4 mb-3 mt-3">

  {addMonths > 0 ? (
    // --- WHEN ADDITIONAL LOAN EXISTS (SIDE BY SIDE) ---
    <div className="d-flex justify-content-between w-100">
      <div>
        <p className="mb-1 text-muted small">Main Loan Month</p>
        <h6 className="fw-bold">{mainMonths} month(s)</h6>
      </div>

      <div>
        <p className="mb-1 text-muted small">Additional Loan Month</p>
        <h6 className="fw-bold">{addMonths} month(s)</h6>
      </div>
    </div>
  ) : (
    // --- WHEN NO ADDITIONAL LOAN (NORMAL SINGLE BLOCK) ---
    <div className='text-center'>
      <p className="mb-1 text-muted small">Full Months Since Last Payment</p>
      <h6 className="fw-bold">{mainMonths} month(s)</h6>
    </div>
  )}

</div>

<div className='col-md-1'></div>

    </>
  )
}


     


  {/* If Interest Due exists → use col-4 for all 3 fields */}
{!hasPaidThisMonth ? (
  <>
    {/* Interest Due */}
    <div className="col-3 mb-3 mt-3">
      <p className="mb-1 text-muted small">Interest Due</p>
      <h6 className="fw-bold text-danger">₹{interest.toFixed(2)}</h6>
    </div>

    {/* Remaining Amount */}
    <div className="col-3 mt-3 highlight-remaining">
      <p className="mb-1 text-muted small">Remaining Amount (incl. interest)</p>
<h6 className="fw-bold text-primary">
  ₹{
    Number(remainingAmountOnly) === 0
      ? Number(customer?.loan_amount || 0) + Number(remainingAmount || 0)
      : Number(remainingAmount || 0)
  }
</h6>
    </div>

   

    {/* Pay Method */}
    <div className="col-6 mt-2">
      <label className="text-muted small">Pay method</label>
      <select
        className="form-select"
        style={{ padding: "10px" }}
        value={paymentMethod}
        onChange={(e) => setPaymentMethod(e.target.value)}
      >
        <option value="" disabled>Select Payment Method</option>
        <option value="cash">Cash</option>
        <option value="upi">UPI</option>
        <option value="bank_transfer">Bank Transfer</option>
      </select>
    </div>

    {paymentMethod === "upi" && (
  <div className="col-md-6">
    <label className="text-muted small">UPI Number</label>
    <input
      type="text"
      className="form-control"
      placeholder="Enter UPI Number"
      value={upiNumber}
      maxLength={12}
      onChange={(e) => setUpiNumber(e.target.value)}
    />
  </div>
)}
  </>
) : (
  <>
    {/* No Interest → Normal 2 column layout */}

    <div className="col-4 mt-2 highlight-remaining">
      <p className="mb-1 text-muted small">Remaining Amount (incl. interest)</p>
      <h6 className="fw-bold text-primary">₹{remainingAmount}</h6>
    </div>

    



{customer?.paid_status === "Closed" ? (
  ""
) : (
  <>
    <div className="col-6 mt-2">
      <label className="text-muted small">Pay method</label>
      <select
        className="form-select"
        style={{ padding: "10px" }}
        value={paymentMethod}
        onChange={(e) => setPaymentMethod(e.target.value)}
      >
        <option value="" disabled>Select Payment Method</option>
        <option value="cash">Cash</option>
        <option value="upi">UPI</option>
        <option value="bank_transfer">Bank Transfer</option>
      </select>
    </div>

    {paymentMethod === "upi" && (
      <div className="col-md-6 mt-2">
        <label className="text-muted small">UPI Number</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter UPI Number"
          value={upiNumber}
          maxLength={12}
          onChange={(e) => setUpiNumber(e.target.value)}
        />
      </div>
    )}
  </>
)}


  </>
)}


    </div>

  </div>

<div className='mt-4 mb-5' style={{ display: 'flex', alignItems: 'center', gap: '20px', padding:'0 13px' }}>
  <label style={{ marginBottom: 0 }}>🟡 Enter Payment Amount (₹)</label>
  {/* <input
    type="number"
    value={calculationAmt}
    onChange={(e) => {
      const val = parseFloat(e.target.value) ;
      setCalculationAmt(val);
      setInterestPaid(Math.min(val, interest));
      setPrincipalPaid(val - Math.min(val, interest));
    }}
    style={{
      width: '120px',
      border: 'none',
      borderBottom: '1px solid #000', 
      outline: 'none',
      padding: '0 0 2px 0', // bottom padding only
      marginBottom: 0,      // make sure line aligns
      borderRadius: 0,
      marginRight:'24px'
    }}
  /> */}

<input
  type="number"
   onWheel={(e) => e.preventDefault()} 
  className='form-controlss'
  value={calculationAmt}
  onChange={(e) => {
    const raw = e.target.value;

    // Allow empty input
    if (raw === "") {
      setCalculationAmt("");
      setInterestPaid("");
      setPrincipalPay("");
      setPayAmount("");
      setIsInterestEdited(false);
      return;
    }

    const val = parseFloat(raw);
    setCalculationAmt(val);

    if (isNaN(val)) return;

    const interestPart = Math.min(val, interest);
    const principalPart = val - interestPart;

    setInterestPaid(interestPart);
    setPrincipalPay(principalPart);

    // Auto-fill bottom input ONLY if user has NOT touched it
    if (!isInterestEdited) {
      setPayAmount(interestPart);
    }
  }}
/>


<div style={{ alignSelf: "flex-end" }}>
  💡 Interest Paid: ₹{interestPaid || 0} | Principal Paid: ₹{principalPay || 0}
</div>

</div>


<div className='row'>
  <div className='col-md-6'>


{(() => {
  const lastPaymentDate = customer?.last_payment_date;
  const today = new Date();

  const rawInterestPaid = customer?.interest_paid;

  // Convert numeric string to number
  const numericInterest = Number(rawInterestPaid);

  let hasPaidThisMonth = false;

  // CASE 1 → backend stored "paid"
  if (rawInterestPaid === "paid") {
    hasPaidThisMonth = true;
  }

  // CASE 2 → numeric interest exists (ex: "120.00")
  else if (!isNaN(numericInterest) && numericInterest > 0 && lastPaymentDate) {
    const lastPay = new Date(lastPaymentDate);

    // same month check
    if (
      lastPay.getMonth() === today.getMonth() &&
      lastPay.getFullYear() === today.getFullYear()
    ) {
      hasPaidThisMonth = true;
    }
  }

  // CASE 3 → first time interest is 0 → allow paying
  // nothing to do

  const expectedInterest = Number(interest.toFixed(2));

  // Show message if interest already paid this month
  if (hasPaidThisMonth) {
    return (
      <div className="alert alert-success mt-3"  style={{ margin: "0px 13px",padding:'25px' }}>
        ✅ இந்த மாத வட்டி ஏற்கனவே செலுத்தப்பட்டுள்ளது.
      </div>
    );
  }

  // === Interest Input Box ===
  return (
    <div className="form-group mt-1" style={{ padding: "0px 13px" }}>
      <label>
        Payment Interest Amount -{" "}
        <span className="text-danger fw-bold">({expectedInterest})</span> ₹
      </label>

      <input
        type="number"
        onWheel={(e) => e.preventDefault()}
        className="form-control"
        value={payAmount}
        onChange={(e) => {
          const val = e.target.value;
          if (!/^\d*\.?\d{0,2}$/.test(val)) return;

          if (val > expectedInterest) {
            toast.error(`❗ Interest cannot exceed ₹${expectedInterest}`);
            return;
          }

          setPayAmount(val);
          setIsInterestEdited(true);
        }}
        placeholder={`Suggested: ₹${expectedInterest}`}
      />

      <small className="text-muted">
        💡 Suggested interest for this period: ₹{expectedInterest}
      </small>
    </div>
  );
})()}



  </div>
  <div className='col-md-6'>
 {/* ✅ Principal always visible */}

 {customer?.paid_status === "Closed" ? (
  <div
    className="alert alert-success text-center mt-3 mb-3"
    style={{ margin: "0px 13px",padding:'25px' }}
  >
    🎉 Your loan is fully paid and closed!
  </div>
) : (


  <div className="form-group  mb-4" style={{ padding: "0px 13px" }}>
    <label>Principal Payment (₹)</label>

    <input
      type="text"
      className="form-control"
value={principalPay === 0 ? "" : principalPay} 
     placeholder={`Enter principal amount (Maximum allowed: ₹${
        (remainingAmountOnly > 0 ? remainingAmountOnly : customer?.loan_amount) ?? 0
      })`}
      onChange={(e) => {
        const val = e.target.value;

       
        if (!/^\d*\.?\d{0,2}$/.test(val)) return;

        const numericVal = val === "" ? 0 : parseFloat(val);

        const loan = Number(customer?.loan_amount ?? 0);
        const remaining = Number(remainingAmountOnly ?? 0);
  setIsPrincipalEdited(true); 
        
        const maxAllowed = remaining > 0 ? remaining : loan;

        if (numericVal > maxAllowed) {
          toast.error(`❗ Principal amount cannot exceed ₹${maxAllowed}.`);
          return;
        }

        setPrincipalPay(val);
      }}
    />

    <small className="text-muted">
      💰 This amount will reduce the main loan balance (principal).
    </small>
  </div>
)}

  </div>

</div>








 


{customer?.paid_status !== "Closed" && (
  <div className="row mt-4" style={{ padding: "0px 13px" }}>

    {/* Loan Closed Date */}
  <div className="col-6">
  <div className="form-group" style={{ width: "100%" }}>
    <label className="mb-2 text-muted small">Loan Closed Date</label>

    <input
      type="date"
      className="form-control"
      value={closedDate}
      onChange={(e) => setClosedDate(e.target.value)}
      onClick={(e) => {
        const input = e.currentTarget;
        if (typeof input.showPicker === "function") input.showPicker();
        else input.focus();
      }}
  //     style={
  //      submit &&
  // isPrincipalEdited &&
  // Number(principalPay || 0) === Number(remainingAmountOnly || 0) &&
  // !closedDate
  //         ? { borderColor: "red" }
  //         : {}
  //     }
    />

   

    {/* {submit &&
  isPrincipalEdited &&
  Number(principalPay || 0) === Number(remainingAmountOnly || 0) &&
  !closedDate && (
    <small className="text-danger">
      ⚠️ Please select Loan Closed Date to fully settle the loan
    </small>
)} */}

  </div>
</div>


    {/* Status */}
    <div className="col-6 text-center mt-4">
      <label>Status</label>
      <h6 className={blinkClosed ? "blink-status text-success" : ""}>
        {paidStatus === "Closed" ? "Closed" : "Pending"}
      </h6>
    </div>

  </div>
)}







 {customer?.paid_status=="Closed"  ?"":<div  style={{padding:'0px 13px'}} className='mb-3'>
<button
  className="btn pay-button mt-3" 
 
  onClick={handlePay}
  disabled={
    (!principalPay || parseFloat(principalPay) <= 0) &&
    (!payAmount || parseFloat(payAmount) <= 0)
  }
>
  Pay
</button>
</div>}       





        </div>

        
      </div>
    </div>
  );
};

export default PayPage;
